import scrollAnimate from 'base/components/scrollAnimate';

var scrolled = false;

export const invalidFieldMessage = (fieldName) => `${fieldName} inválido`;

export const populateFieldErrors = (fieldErrors) => {
    scrolled = false;
    fieldErrors.forEach(function (error, i) {

        if (fieldErrors.length == 1 && error["dwfrm_billing_otherPaymentFields_termsandconditions"]) {
            $("#dwfrm_billing_otherPaymentFields_termsandconditions").trigger("click");
        }

        $.each(error, function (attr) {
            if (attr.indexOf('dwfrm_billing_addressFields') !== -1 && !scrolled) {
                scrollAnimate($('.billing-address-block'));
                scrolled = true;
            }

            if (attr.indexOf('dwfrm_billing_automaticDebitFields') !== -1 && !scrolled) {
                scrollAnimate($(".payment-form-fields"));
                scrolled = true;
            }

            populateErrorMessage($("*[name=" + attr + "]"), error[attr]);
        });
    });
};

export const populateErrorMessage = ($field, message) => {
    if(!scrolled) {
        scrollAnimate($field);
    }

    $field.addClass("is-invalid").removeClass("success");

    const $formGroup = $field.closest(".form-group");
    let $feedback    = $formGroup.find(".invalid-feedback");

    if (!$feedback.length) {
        const describedBy = $field.attr("aria-describedby");

        if (describedBy) {
            describedBy.split(/\s+/).some((id) => {
                if (!id) {
                    return false;
                }

                const $byId = $(document.getElementById(id));

                if ($byId.length) {
                    $feedback = $byId;
                    return true;
                }

                return false;
            });
        }
    }

    if (!$feedback.length) {
        $feedback = $formGroup.nextAll(".invalid-feedback").first();
    }

    $feedback.text(message);
};

export const populateErrorMessageWithHtml = ($field, message) => {
    $field.addClass("is-invalid").removeClass("success");
    $field.closest(".form-group").find(".invalid-feedback").html(message);
};

export const clearFieldErrorMessage = ($field) => {
    $field.removeClass("is-invalid");
    $field.closest(".form-group").find(".invalid-feedback").text("");
};
